import { biClick } from '@tencent/fit-bi-sdk';
import { GiftPackUserStatus } from '@tencent/wphk-components-discount-code/business/bi';
import { ActState } from '@tencent/wphk-components-discount-code/business/codeAct';
import { useNewUserStore } from '../../../../store/new-user-module';
import { toRefs } from 'vue';
import { useGlobalBi } from '@/hooks/use-global-bi';
import { url } from '@tencent/wphk-base-utils';

/** 优惠码活动状态上报参数 */
type FormatStatusParams = {
  actState: ActState,
  awardCode: string,
  codeFromUrl: string,
  canSwitch: boolean,
};

/** 格式化优惠码领取状态，便于bi上报 */
const formatGiftPackUserStatus = ({ actState, awardCode, codeFromUrl, canSwitch }: FormatStatusParams) => {
  if (canSwitch) {
    return GiftPackUserStatus.SWITCH_RECEIVE;
  }
  if (actState === ActState.UNRECEIVED) {
    return GiftPackUserStatus.UNRECEIVED;
  }
  if (awardCode === codeFromUrl) {
    return GiftPackUserStatus.CUR_MERCHANT_RECEIVED;
  }
  return GiftPackUserStatus.OTHER_MERCHANT_RECEIVED;
};

export const useBiReport = () => {
  const { getBiExt } = useGlobalBi();
  const commonNewUserStore = useNewUserStore();
  const { actInfo } = toRefs(commonNewUserStore);
  const globalBiExt = getBiExt();
  const { actState, awardCode, codeFromUrl, canSwitch } = actInfo.value;
  const localBiExt = {
    ...globalBiExt,
    fmerchantid: globalBiExt.fmerchantid || url.getUrlParam('merchantId') || '',
    fspid: globalBiExt.fspid || url.getUrlParam('spid') || '',
    fgiftpackuserstatus: formatGiftPackUserStatus({
      actState,
      awardCode,
      codeFromUrl,
      canSwitch,
    }),
  };

  /** 埋点上报函数 */
  const biReport = (action: string, error = '', ext = {}) => {
    const exts = {
      ...localBiExt,
      ferror: error,
      ...ext,
    };
    biClick(`common_new_user_module.${action}`, exts);
  };

  return {
    biReport,
    biExt: localBiExt,
  };
};
